var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('MainHeader'),_c('div',{staticClass:"app-body"},[_c('main',{staticClass:"main"},[_c('Breadcrumb',{attrs:{"list":_vm.list}}),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1)]),_c('MainFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }